import Http from '../Http';

const baseUrl = `${process.env.VAPI_BASE_URL}/permissions`;

export default {
  list: () => Http.get(baseUrl),
};
